import DOMPurify from 'dompurify'

const ALLOWED_TAGS = ['h1', 'h2', 'h3', 'b', 'i', 'u', 'br', 'ul', 'ol', 'li', 'p', 'a', 'font', 'span', 'small', 'big']
const ALLOWED_ATTR = ['href', 'color', 'style']
const COLOR_PROPS = new Set(['color', 'background-color', 'background'])

/** Returns true when the string contains at least one HTML tag. */
export function hasHtmlTags(text: string): boolean {
  return /<[a-zA-Z][^>]*>/.test(text)
}

/**
 * Sanitizes HTML for safe rendering in quote text fields.
 * Allowlist: h1-h3, b, i, u, br, ul, ol, li, p, a, font, span, small, big.
 * Attributes: href, color, style (style restricted to color properties).
 */
export function sanitizeQuoteHtml(dirty: string): string {
  const clean = DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    FORCE_BODY: false,
  })
  // Strip style attributes to color-only declarations
  return clean.replace(/style="([^"]*)"/gi, (_match, styleValue: string) => {
    const colorOnly = styleValue
      .split(';')
      .filter((decl: string) => {
        const prop = decl.split(':')[0]?.trim().toLowerCase()
        return prop !== undefined && prop !== '' && COLOR_PROPS.has(prop)
      })
      .join('; ')
      .trim()
    return colorOnly ? `style="${colorOnly}"` : ''
  })
}
